module.exports = __webpack_public_path__ + "img/yahoo.c784e6d0.png";